module.exports = __webpack_public_path__ + "static/media/head-side-brain.7ecc3134.svg";